import React, { FC, useState } from "react";
import { useTranslation } from "react-i18next";

import { ICatalogue } from "../../../apis/useGetCatalogueData/types";
import { displayCentsWithDollarSign } from "../../../common/helpers/stringUtils";
import I18nText from "../../../components/I18nText/I18nText";
import { Image } from "../../../components/elements";
import PopupDialog from "../../../components/elements/PopupDialog/PopupDialog";
import QuantitySelector from "../../../components/elements/Selection/quantity/QuantitySelector";
import "./ProductModal.scss";

interface IProductModalProps {
	product: ICatalogue;
	currentQuantity: number;
	onClose: () => void;
	onAddToCart: (_quantity: number) => void;
}

const ProductModal: FC<IProductModalProps> = ({
	product,
	currentQuantity,
	onClose,
	onAddToCart,
}) => {
	const { t } = useTranslation();
	const [quantity, setQuantity] = useState<number>(currentQuantity || 1);

	const handleConfirm = () => {
		if (quantity > 0) {
			onAddToCart(quantity);
		}
	};

	return (
		<PopupDialog
			data-testid="ProductModal"
			open={true}
			onClose={onClose}
			className="ProductModal"
			content={
				<div className="ProductModalContent">
					<div className="ProductModalImageContainer">
						<Image className="ProductModalImage" src={product.product_image} alt={product.title} />
					</div>
					<div className="ProductModalInfo">
						<I18nText
							className="ProductModalTitle"
							enText={product.title}
							cnText={product.title_cn}
						/>
						<I18nText
							className="ProductModalDescription"
							enText={product.description}
							cnText={product.description_cn}
						/>
						<div className="ProductModalPrice">{displayCentsWithDollarSign(product.price)}</div>
					</div>
					<div className="ProductModalQuantity">
						<span className="QuantityLabel">{t("listPage.modal.quantity")}</span>
						<QuantitySelector
							max={10}
							onChange={setQuantity}
							initValue={quantity}
							testid="product-modal-quantity"
							inventoryCount={product.inventory_count}
							showZero={false}
						/>
					</div>
				</div>
			}
			buttons={[
				{
					text: t("listPage.modal.cancel"),
					onClick: onClose,
					className: "ProductModalCancel",
				},
				{
					text: t("listPage.modal.addToCart"),
					onClick: handleConfirm,
					className: "ProductModalConfirm",
				},
			]}
		/>
	);
};

export default ProductModal;
